export default __webpack_public_path__ + "static/media/Not uploaded.8f123963.svg";